import { render, staticRenderFns } from "./SistemaIndisponivel.vue?vue&type=template&id=892f61a2&"
import script from "./SistemaIndisponivel.vue?vue&type=script&lang=js&"
export * from "./SistemaIndisponivel.vue?vue&type=script&lang=js&"
import style0 from "./SistemaIndisponivel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports